import React from "react";
import styled from "styled-components";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { mobile } from "../responsive";

const Button = styled.a`
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 55px;
  height: 55px;
  background-color: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  z-index: 1200;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
  }

  ${mobile({
    right: "15px",
    bottom: "15px",
    width: "50px",
    height: "50px",
  })}
`;

const WhatsAppButton = () => {
  return (
    <Button
      href="https://wa.me/919557240576"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <WhatsAppIcon fontSize="large" />
    </Button>
  );
};

export default WhatsAppButton;